import styled from 'styled-components';

export const StepContainer = styled.div`
  padding: 0;
  background-color: ${(props: any) => props.theme.colors.interfacePure0};
  border-radius: 8px;
  min-height: 400px;
`;


export const StepBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background-color: ${(props: any) => props.theme.colors.primaryRed400};
  color: ${(props: any) => props.theme.colors.pureWhite};
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
`;

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SectionContainer = styled.div`
  margin-bottom: 32px;
`;

export const SectionTitle = styled.h2`
  font-size: 1rem;
  font-weight: 700;
  color: ${(props: any) => props.theme.colors.c2d3748};
  margin: 0 0 16px 0;
`;

export const FieldRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 12px;
  align-items: end;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const Label = styled.label`
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: ${(props: any) => props.theme.colors.c4a5568};
  margin-bottom: 6px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid ${(props: any) => props.theme.colors.ce2e8f0};
  border-radius: 6px;
  font-size: 0.95rem;
  color: ${(props: any) => props.theme.colors.c2d3748};

  &::placeholder { color: ${(props: any) => props.theme.colors.ca0aec0}; }
`;

export const Select = styled.select`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid ${(props: any) => props.theme.colors.ce2e8f0};
  border-radius: 6px;
  font-size: 0.95rem;
  color: ${(props: any) => props.theme.colors.c2d3748};
  background: ${(props: any) => props.theme.colors.interfacePure0};
`;

export const AddButton = styled.button<{disabled?: boolean}>`
  height: 48px;
  padding: 0 16px;
  background-color: ${props => props.disabled ? 'var(--ccbd5e0)' : 'var(--ce52940)'};
  color: ${props => props.disabled ? 'var(--c9ca3af)' : 'white'};
  border: none;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.3s;
  white-space: nowrap;

  &:hover {
    ${props => props.disabled ? '' : 'transform: scale(1.05);'}
  }

  &:disabled {
    background-color: ${(props: any) => props.theme.colors.ccbd5e0};
    color: ${(props: any) => props.theme.colors.c9ca3af};
    transform: none;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 44px;
  }
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ListItem = styled.li`
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 16px;
  align-items: center;
  padding: 16px 20px;
  background-color: ${(props: any) => props.theme.colors.cf3f7fb};
  border: none;
  border-radius: 12px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto;
    gap: 12px;
    padding: 16px;
    
    > div:nth-child(1) {
      grid-row: 1;
      margin-bottom: 8px;
    }
    
    > div:nth-child(2) {
      grid-row: 2;
      justify-self: start;
      margin-bottom: 8px;
    }
    
    > div:nth-child(3) {
      grid-row: 3;
      justify-self: end;
    }
  }
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })``;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background-color: transparent;
  color: ${(props: any) => props.theme.colors.ce53e3e};
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props: any) => props.theme.colors.cfde8e8};
    transform: scale(1.1);
  }

  svg {
    width: 16px;
    height: 16px;
  }

  svg path {
    fill: ${(props: any) => props.theme.colors.ce53e3e};
  }
`;

export const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  background-color: ${(props: any) => props.theme.colors.cedf2f7};
  color: ${(props: any) => props.theme.colors.c2d3748};
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
`;

export const ErrorText = styled.span`
  display: block;
  color: ${(props: any) => props.theme.colors.ce53e3e};
  font-size: 0.8rem;
  margin-top: 6px;
`;


